import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=46115f14"
import script from "./main.ts?vue&type=script&lang=js&external"
export * from "./main.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports